import React, { useContext } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import { ROUTES } from '../../constants/routes';
import { userHasFn, SUB_APPS } from '../../utils/rbac';
import SubAppHeaderActions from '../../components/SubAppHeaderActions';

const navClass = ({ isActive }) =>
  `nav-link ${isActive ? 'active fw-semibold' : ''}`;

function RiskLayout() {
  const { user } = useContext(AuthContext);
  const canChecklistAdmin = userHasFn(user, SUB_APPS.RISK_CHECKLIST, 'admin');

  return (
    <div className="container-fluid mt-3 px-3 app-shell-page sub-app-white-nav">
      <div className="app-layout-bar d-flex flex-wrap justify-content-between align-items-center gap-2">
        <h1 className="app-layout-title mb-0">Risk Checklist</h1>
        <SubAppHeaderActions
          subAppHomePath={ROUTES.RISK}
          subAppHomeLabel="Risk"
          navButtonClassName="btn btn-sm bg-white text-dark border"
        />
      </div>

      <ul className="nav nav-tabs mb-3">
        <li className="nav-item">
          <NavLink to={ROUTES.RISK} end className={navClass}>
            Home
          </NavLink>
        </li>
        <li className="nav-item">
          <NavLink to={ROUTES.RISK_REPORTS} className={navClass}>
            Reports
          </NavLink>
        </li>
        {canChecklistAdmin && (
          <li className="nav-item">
            <NavLink to={ROUTES.RISK_ADMIN} className={navClass}>
              Admin
            </NavLink>
          </li>
        )}
      </ul>

      <Outlet />
    </div>
  );
}

export default RiskLayout;
